//set some type of token for confirmation page as well so that user can open it infinite times

import React, { Component } from 'react';
import LoadingDiv from '../mobile/mobLoadingDiv';
//import Parser from 'html-react-parser'; //imported to render html from variable, had to be installed seperately
import errorImage from '../images/error_image.png';
import swal from 'sweetalert';

class ConfirmationScreen extends Component {

  constructor(props) {
  	super(props);
    this.state = {
      order_id: this.props.order_id,
      paypal_id: this.props.paypal_id,
      success: 0,
      api_loaded: 0
    };
  }

  componentDidMount(){
  		document.getElementById("loader-wrapper").style.display = "block"; //showing loading sign till the api request is complete
	  	var req_array = {"access_token": this.props.access_token, "order_id": this.state.order_id, "paypal_id": this.state.paypal_id};

	  	var final_req_array = JSON.stringify(req_array);

		fetch('https://checkout-api'+this.props.sandbox_url_creator+'.highape.com/web/v1/finalize_order', {
		    method: 'POST',
		    headers: {
		    	'Accept': 'application/json'
		  	},
	   		body: final_req_array
	 	})
	    .then(function(response) {

	        return response.json()

	    }).then(function(result) {
	        this.setState({
			    success: result['success'],
			    msg: result['msg'],
			    event_link: result['event_link'],
			    name: result['name'],
			    event_note: result['event_note'],
			    event_name: result['event_name'],
			    event_venue: result['event_venue'],
			    venue_city: result['venue_city'],
			    currency: result['currency'],
			    currency_icon: result['currency_icon'],
			    venue_location: result['venue_location'],
			    event_time_date: result['event_time_date'],
			    invoice_id: result['invoice_id'],
			    ticket_price: result['ticket_price'],
			    discount: result['discount'],
			    cost_price: result['cost_price'],
			    conv_fee: result['conv_fee'],
			    tax: result['tax'],
			    offer_price: result['offer_price'],
			    total_amount: result['total_amount'],
			    organised_by: result['organised_by'],
			    org_email: result['org_email'],
			    org_phone: result['org_phone'],
			    tickets: result['tickets'],
			    offers: result['offers'],
			    qr_code: result['qr_code'],
			    api_loaded: 1
			});

	    }.bind(this));
  }


  render() {

  	if(this.state.api_loaded===0){
  		return(<div><LoadingDiv /></div>);
  	}else if(this.state.api_loaded===1){
	  	if(this.state.success===0){
	  		return (<div>
	  					<HeaderConfirmation />
	  					<OrderFailed order_id={this.props.order_id} event_link={this.state.event_link} venue_city={this.state.venue_city} />
	  			    </div>);
	  	}else if(this.state.success===1){
	  		return (<div>
	  					<HeaderConfirmation />
	  					<OrderConfirmed order_id={this.props.order_id} event_link={this.state.event_link} name={this.state.name} event_note={this.state.event_note} event_name={this.state.event_name} event_venue={this.state.event_venue} venue_city={this.state.venue_city} currency={this.state.currency} currency_icon={this.state.currency_icon} venue_location={this.state.venue_location} event_time_date={this.state.event_time_date} invoice_id={this.state.invoice_id} ticket_price={this.state.ticket_price} discount={this.state.discount} cost_price={this.state.cost_price} conv_fee={this.state.conv_fee} tax={this.state.tax} offer_price={this.state.offer_price} total_amount={this.state.total_amount} organised_by={this.state.organised_by} org_email={this.state.org_email} org_phone={this.state.org_phone} tickets={this.state.tickets} offers={this.state.offers} qr_code={this.state.qr_code} />
	  			    </div>);
	  	}else {
	  		swal(this.state.msg);
	  		return (<div>
	  					<HeaderConfirmation />
	  					<OrderFailed order_id={this.props.order_id} event_link={this.state.event_link} venue_city={this.state.venue_city} />
	  			    </div>);
	  	}
	}

  }

}


class HeaderConfirmation extends Component {

	render() {
		return (<div>
					<div className="col-sm-12 col-xs-12 col-md-12 mob_confirmation_header">
						<a href="https://highape.com"><img className="logo_confirmation_mob" src="https://highape.com/images/android-logo.png" alt="HighApe Logo" /></a>
					 </div>
				</div>);
	}

}

class OrderFailed extends Component {

	render() {
		let city = this.props.venue_city.toLowerCase();
		let retry_link = "/?event_name="+this.props.event_link+"&city="+city; //add city name here as well
		//alert(retry_link);
		return (<div className="error_conf_msg">
				<img className="error_image_conf" src={errorImage} alt="Error Display for Payment" />
				<div className="error_msg_conf_p">
					<p>Something went wrong while processing your payment. We are sorry for the inconvenience caused to you. You can note your Order No: <b>{this.props.order_id}</b>.</p>
					<p>In case your amount has been deducted, it should be automatically refunded back to you.</p>
					<p>If you require any support, you can mail us at contact@highape.com or WhatsApp us at +91-8618286048. Please quote your order number for quick assistance.</p>
					<a href={retry_link}>Click here to try booking again.</a>
				</div>
			</div>);
	}

}

class OrderConfirmed extends Component {

	render() {

		var ticket_list_div = [];
		for(var i = 0; i < this.props.tickets.length; i++) {
			ticket_list_div.push(<p className="ticket_list_conf">{this.props.tickets[i]["ticket_name"]}: {this.props.tickets[i]["ticket_count"]}</p>);
		}
		for(var j = 0; j < this.props.offers.length; j++) {
			ticket_list_div.push(<p className="ticket_list_conf">{this.props.offers[j]["offer_name"]}: {this.props.offers[j]["offer_count"]}</p>);
		}
		let city = this.props.venue_city.toLowerCase();
		var event_link_href = "https://highape.com/"+city+"/events/"+this.props.event_link+"?utm_source=conf_page_link";

		let ticket_price_to_show = this.props.ticket_price + this.props.offer_price;
		let subtotal_to_show = this.props.cost_price + this.props.offer_price;

		return (<div>
				<div className="name_conf_div col-sm-7 col-xs-7">
					<p className="name_conf_div_name">Dear {this.props.name}</p>
					<p>Your booking is <b>confirmed</b>!</p>
				</div>
				<div className="col-sm-5 col-xs-5 image_qr_code">
					<img src={this.props.qr_code} alt="QR Code for booking" />
				</div>
				<div className="order_ticket_main_div col-sm-12 col-xs-12">

					<p className="order_id_no">Order No: {this.props.order_id}</p>
					<p className="special_det_conf">Show your Email/SMS pass at the venue to avail your entry. Please Note: {this.props.event_note}</p>

					<div className="col-sm-12 col-xs-12 red_event_ticket_det">
						<div className="col-sm-8 col-xs-8 red_event_det">
							<p className="event_conf_title"><b>Event Name: </b>{this.props.event_name}</p>
							<p className="venue_conf_title"><b>Venue: </b>{this.props.event_venue}</p>
							<p className="date_conf_title">{this.props.event_time_date}</p>
						</div>
						<div className="col-sm-4 col-xs-4 ticket_list_conf_parent">
							{ticket_list_div}
						</div>
					</div>

					<div className="col-sm-12 col-xs-12 invoice_div_conf">
						<div className="order_invoice_div">
							<p className="order_summary">Order Summary</p>
							<p className="invoice_id">Invoice ID: {this.props.invoice_id}</p>
						</div>
						<div className="price_bottom_border col-sm-12 col-xs-12">
							<div className="col-sm-9 col-xs-9 amounts_conf_page_text">
								<p>Price</p>
								<p>Discount</p>
								<p>Subtotal</p>
							</div>
							<div className="col-sm-3 col-xs-3 amounts_conf_page_number">
								<p>{ticket_price_to_show}</p>
								<p>{this.props.discount}</p>
								<p>{subtotal_to_show}</p>
							</div>
						</div>
						<div className="price_bottom_border conv_tax_parent col-sm-12 col-xs-12">
							<div className="conv_tax_conf_text col-sm-9 col-xs-9">
								<p>Convenience Charge</p>
								<p>CGST+SGST/IGST</p>
							</div>
							<div className="col-sm-3 col-xs-3 conv_tax_conf_number">
								<p>{this.props.conv_fee}</p>
								<p>{this.props.tax}</p>
							</div>	
						</div>	
						<div className="total_amount_conf_text col-sm-9 col-xs-9">
							<p>AMOUNT PAID</p>
						</div>
						<div className="col-sm-3 col-xs-3 total_amount_conf_number">
							<p>{this.props.total_amount}</p>
						</div>											
					</div>

					<div className="col-sm-12 col-xs-12 tax_deductor_details">
						<p>Issued By: HIGHESTA SERVICES PRIVATE LIMITED</p>
						<p>GSTIN: 29AADCH8184L1ZW</p>
					</div>
				</div>
				<div className="organiser_detail_conf col-sm-12 col-xs-12">
					<p className="organised_by_conf">Organised By: {this.props.organised_by}</p>
					<p className="organiser_email_conf">Email ID: {this.props.org_email}</p>
					<p className="organiser_email_conf">Contact No: {this.props.org_phone}</p>
				</div>
				<div className="imp_instruc_conf col-sm-12 col-xs-12">
					<p className="imp_struc_title">Important Instructions</p>
					<p className="imp_struc_text">Kindly show your Email/SMS at the venue to avail your entry.</p>
					<p className="imp_struc_text">This pass is valid only if you fulfill all the T&Cs mentioned on the event page at our website. To check the event page once again, please <a href={event_link_href}>click here</a>.</p>
					<p className="imp_struc_text">Venue rules apply.</p>
					<p></p>
					<p className="imp_struc_text">We hope you have a great time!</p>
				</div>
			   </div>);
	}

}

export default ConfirmationScreen;


// WEBPACK FOOTER //
// ./src/mobile/mobConfirmationScreen.js